import React from 'react';
import { Services1 } from '../components/Data/Arabic';
import { Services2 } from '../components/Data/English';

const Services = ({lang}) => {

      const Data = lang ? Services2 : Services1;

  return (
    <div className="px-32 lg:px-16 md:px-14 py-10 lg:py-10 sm:px-2 lg:w-full sm:w-full" id='services'>
      <div className="section mx-auto p-10 lg:p-1 sm:p-0 lg:w-[82%] sm:w-11/12 xl:max-w-[1400px] xl:mx-auto">
        <div className=" m-auto lg:p-6 p-11 sm:p-6 basis-4/5">
          <div className=" mx-auto text-center relative flex justify-center">
            <h2 className="xl:text-5xl lg:text-4xl sm:text-3xl py-8 mb-8 text-center font-black">ماذا تقدم أكاديميتنا ؟</h2>
            <span className="bg-orange lg:w-44 w-40 sm:w-36 h-1  absolute rounded mt-24 lg:mt-28"></span>
          </div>
          {
            Data.map(item => (
              <div key={item.id}>
              <p className="font-black text-center leading-loose xl:text-3xl lg:text-2xl md:leading-10 md:text-2xl lg:px-5 xl:px-44 xl:leading-loose lg:leading-loose  px-40 mb-8 mt-8 md:px-10 sm:text-xl sm:px-2">
                {item.firstP}
              </p>
              <p className="font-black text-center leading-loose xl:text-3xl lg:text-2xl  md:leading-10 md:text-2xl lg:px-2 xl:px-44 xl:leading-loose lg:leading-loose  px-40 mb-8 md:px-10 sm:text-xl sm:px-2">
                {item.lastP}
              </p>
            </div>
            ))
          }
          {/* <span className="font-black text-center lg:text-2xl lg:px-40 xl:px-44 lg:leading-10  px-40 block text-lightBlue sm:text-xl sm:px-6"><a href="app.js">المزيد ...</a></span> */}
        </div>
      </div>
    </div>
  )
}

export default Services;
